import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import { Trans } from "react-i18next";
import type { ObjPathProxy } from "ts-object-path";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import {
	getResourcePath,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationSectionHeader } from "web_myplann/Inspiration/Components/InspirationSectionHeader";

type Props = {
	intro: ObjPathProxy<MyPlannResourceDictionary, string>;
	exampleTitle: ObjPathProxy<MyPlannResourceDictionary, string>;
	exampleHint: ObjPathProxy<MyPlannResourceDictionary, string>;
	children: ReactNode;
};

export const InspirationColdIntro: FC<Props> = ({
	intro,
	exampleTitle,
	exampleHint,
	children,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	const cardBg = theme.palette.background.paper;

	return (
		<>
			<Stack
				bgcolor={cardBg}
				px={theme.spacingTokens.lg}
				py={theme.spacingTokens.xl}
			>
				<Typography variant="body1" color={theme.palette.grey[700]} relaxed>
					<Trans
						i18nKey={getResourcePath(intro)}
						components={{
							b: <Typography component="span" variant="body1" strong />,
						}}
					/>
				</Typography>
			</Stack>

			<InspirationSectionHeader title={t(exampleTitle)} />

			<Stack
				bgcolor={cardBg}
				px={theme.spacingTokens.lg}
				py={theme.spacingTokens.lg}
				gap={theme.spacingTokens.md}
			>
				{children}

				<Typography
					variant="caption"
					color={theme.palette.grey[500]}
					textAlign="center"
				>
					{t(exampleHint)}
				</Typography>
			</Stack>
		</>
	);
};
